// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-page-container {
  position: relative;
  min-height: calc(100vh - 120px);
  padding-bottom: 80px;
}

.create-sample-fab {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.create-sample-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}
.create-sample-fab svg {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Sample/Sample.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,+BAAA;EACA,oBAAA;AACJ;;AAEA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;EACA,qDAAA;AACJ;AACI;EACI,qBAAA;EACA,yCAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;AAAR","sourcesContent":[".sample-page-container {\n    position: relative;\n    min-height: calc(100vh - 120px);\n    padding-bottom: 80px;\n}\n\n.create-sample-fab {\n    position: fixed;\n    bottom: 30px;\n    right: 30px;\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n    z-index: 1000;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n        transform: scale(1.1);\n        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n    }\n\n    svg {\n        width: 24px;\n        height: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
